export function filterNumberStrict(search = '', value = '') {
  try {
    const source_value = value.toString();
    const search_value = search.toString();
    return source_value.indexOf(search_value) === 0;
  } catch (e) {
    console.error('filterNumberStrict error:', e);
    return false;
  }
}

export function filterName(search = '', value = '') {
  try {
    const source_value = value.toString().toUpperCase();
    const search_value = search.toString().toUpperCase();
    return source_value.indexOf(search_value) !== -1;
  } catch (e) {
    console.error('filterName error:', e);
    return false;
  }
}
